import styled from '@emotion/styled';

import { Container, TextBlockWithAside, TextBlockWithQuotes } from '@features';
import { getFont } from '@styles/mixins/fonts';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';
import { sectionGridTemplateBase } from '@styles/mixins/sectionGridTemplate';
import { visuallyHidden } from '@styles/mixins/visuallyHidden';

export const StyledContainer = styled(Container)`
  --title-parts-margin: 5px;

  grid-template-areas:
    'first-title-part  .'
    'second-title-part .'
    'third-title-part  .'
    'text-block        quote';

  padding-bottom: 290px;

  ${sectionGridTemplateBase};

  ${getMediaqueryStyled('xl')} {
    --title-parts-margin: 10px;

    padding-bottom: 325px;
  }

  ${getMediaqueryStyled('lg')} {
    --title-parts-margin: 3px;

    padding-bottom: 280px;
  }

  ${getMediaqueryStyled('md')} {
    --title-parts-margin: 5px;
    grid-template-areas: 'first-title-part' 'second-title-part' 'third-title-part' 'quote' 'text-block';
    padding-top: 80px;
    padding-bottom: 295px;
  }

  ${getMediaqueryStyled('sm')} {
    --title-parts-margin: 3px;
    padding-bottom: 255px;
  }
`;

export const MainTitle = styled.h1`
  ${visuallyHidden};
`;

// TODO: вынести на уровень всех секций
const TitlePart = styled.span`
  ${getFont('title')};
`;

export const FirstTitlePart = styled(TitlePart)`
  grid-area: first-title-part;
  margin-bottom: var(--title-parts-margin);
`;

export const SecondTitlePartDesktop = styled(TitlePart)`
  grid-area: second-title-part;
  margin-bottom: var(--title-parts-margin);

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const SecondTitlePartTablet = styled(TitlePart)`
  display: none;

  ${getMediaqueryStyled('md')} {
    display: block;
    grid-area: second-title-part;
    margin-right: 5px;
    margin-bottom: var(--title-parts-margin);
    justify-self: end;
  }

  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

export const SecondTitlePartMobile = styled(TitlePart)`
  display: none;

  ${getMediaqueryStyled('sm')} {
    display: block;
    grid-area: second-title-part;
    margin-bottom: var(--title-parts-margin);
  }
`;

export const ThirdTitlePartNotTablet = styled(TitlePart)`
  grid-area: third-title-part;
  justify-self: end;
  margin-right: 235px;
  margin-bottom: 55px;

  ${getMediaqueryStyled('xl')} {
    margin-right: 250px;
    margin-bottom: 45px;
  }

  ${getMediaqueryStyled('lg')} {
    margin-right: 160px;
    margin-bottom: 40px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }

  ${getMediaqueryStyled('sm')} {
    display: block;
    margin-right: 10px;
    margin-bottom: 40px;
  }
`;

export const ThirdTitlePartTablet = styled(TitlePart)`
  display: none;

  ${getMediaqueryStyled('md')} {
    display: block;
    grid-area: third-title-part;
    margin-bottom: 50px;
  }

  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

// TODO: вынести на уровень всех секций
export const Quote = styled(TextBlockWithQuotes)`
  grid-area: quote;
  align-self: start;

  ${getMediaqueryStyled('md')} {
    margin-bottom: 40px;
  }
`;

// TODO: вынести на уровень всех секций
export const TextBlock = styled(TextBlockWithAside)`
  grid-area: text-block;
  margin-top: 75px;

  ${getMediaqueryStyled('xl')} {
    margin-top: 55px;
  }
  ${getMediaqueryStyled('lg')} {
    margin-top: 35px;
  }

  ${getMediaqueryStyled('md')} {
    margin-top: 0;
  }
`;

// TODO: вынести на уровень всех секций
export const Subtitle = styled.h3`
  margin: 0;
  ${getFont('subtitle')}

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;
